"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var react_redux_1 = require("react-redux");
var react_hot_loader_1 = require("react-hot-loader");
var mobile_1 = require("@caddigital/sok-ui/lib/utils/mobile");
var translate_1 = require("utils/translate");
var cookie = require("utils/cookies");
var constants_1 = require("utils/constants");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var translation_2 = require("@caddigital/sok-reducers/lib/utils/translation");
(0, translation_1.setLocalizationFunction)(translation_2.getLocalization);
if (!mobile_1.isLocalStorageSupported) {
    alert('SokoPro cannot work in Private Mode. Please switch to Normal Mode.');
    throw new Error();
}
var Actions = require("@caddigital/sok-reducers/lib/actions");
var locale = window.navigator.language || constants_1.DEFAULT_LANGUAGE;
require("../assets/sass/index.scss");
var RootApp_1 = require("./routers/RootApp");
var store_1 = require("./store");
var GlobalComponents_1 = require("components/GlobalComponents");
var store = (0, store_1.configureStore)();
var loc = /(.*)(-)/.exec(locale);
var parsed = loc && loc.length > 0 ? loc[1] : 'en';
var lang = ['en', 'fi', 'sv', 'ru'].find(function (x) { return x.startsWith(parsed); });
function getPath() {
    if (window.location.pathname.startsWith('/sso') ||
        window.location.pathname.startsWith('/authorizing')) {
        return '';
    }
    return window.location.pathname;
}
var lastLanguage = (0, translate_1.getLanguage)();
var isProduction = __PRODUCTION__;
var pathname = getPath();
var pathLang = /^\/([\w]+)\/?/.exec(pathname);
var tmz = -1 * (new Date().getTimezoneOffset() / 60);
cookie.setCookie('timezone', tmz.toString());
if (pathLang && pathLang.length > 0 && pathLang[1].length < 4) {
    (0, translate_1.setLanguage)(pathLang[1]);
    store.dispatch(Actions.translations.fetchLanguageRequest(pathLang[1], isProduction));
}
else if (lastLanguage) {
    (0, translate_1.setLanguage)(lastLanguage);
    store.dispatch(Actions.translations.fetchLanguageRequest(lastLanguage, isProduction));
}
else if (lang) {
    (0, translate_1.setLanguage)(lang);
    store.dispatch(Actions.translations.fetchLanguageRequest(lang, isProduction));
}
else {
    (0, translate_1.setLanguage)(constants_1.DEFAULT_LANGUAGE);
    store.dispatch(Actions.translations.fetchLanguageRequest(constants_1.DEFAULT_LANGUAGE, isProduction));
}
store.dispatch(Actions.info.BuildInfo.request());
var renderApp = function (Root) {
    ReactDOM.render(React.createElement(react_hot_loader_1.AppContainer, null,
        React.createElement(react_redux_1.Provider, { store: store },
            React.createElement(Root, null))), document.getElementById('sok-mount'));
};
renderApp(RootApp_1.RootApp);
var renderGlobaComponents = function (Root) {
    ReactDOM.render(React.createElement(react_hot_loader_1.AppContainer, null,
        React.createElement(react_redux_1.Provider, { store: store },
            React.createElement(Root, null))), document.getElementById('sok-global-components'));
};
renderGlobaComponents(GlobalComponents_1.GlobalComponents);
if (module.hot) {
    ;
    module.hot.accept('./routers/RootApp', function () {
        return renderApp(require('./routers/RootApp').RootApp);
    });
    module.hot.accept('./components/GlobalComponents', function () {
        return renderGlobaComponents(require('./components/GlobalComponents').GlobalComponents);
    });
}
document.addEventListener('gesturestart', function (e) {
    e.preventDefault();
    document.body.style.zoom = '0.99';
});
document.addEventListener('gesturechange', function (e) {
    e.preventDefault();
    document.body.style.zoom = '0.99';
});
document.addEventListener('gestureend', function (e) {
    e.preventDefault();
    document.body.style.zoom = '0.99';
});
